"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Observer2 = require("./Observer");

var _Observer3 = _interopRequireDefault(_Observer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TariffPointsModel = function (_Observer) {
    _inherits(TariffPointsModel, _Observer);

    function TariffPointsModel(observers, id, request) {
        _classCallCheck(this, TariffPointsModel);

        var _this = _possibleConstructorReturn(this, (TariffPointsModel.__proto__ || Object.getPrototypeOf(TariffPointsModel)).call(this, observers, id, request));

        _this.TariffPoints = [];

        _this.SelectedTariffId = -1;
        return _this;
    }
    /**
     * Liste von Tariffpunkte
     * @type {array}
     */


    _createClass(TariffPointsModel, [{
        key: "GetTariffPoints",
        value: function GetTariffPoints(searchString, ticketStart) {
            if (searchString !== null && searchString !== undefined && ticketStart !== null && ticketStart !== undefined) {
                var me = this;
                this.request.setRequest("/TariffPoints?searchString=" + searchString + "&ticketStart=" + ticketStart);
                this.request.setType("GET");
                this.request.setCallback(function (result) {
                    if (result) {
                        if (result.Data) {
                            me.TariffPoints = result.Data;
                        }
                    }
                    var id = me.Id ? me.Id : "TariffPoint";
                    me.Notify(id);
                });
                this.request.doRequest();
            }
        }
    }, {
        key: "GetTariffPointsByTicketId",
        value: function GetTariffPointsByTicketId(ticketId, searchString, ticketStart, tariffPointId, showTairfPointIdent) {
            var me = this;

            this.request.setRequest("/TariffPoints");
            this.request.setData(JSON.stringify({
                searchString: searchString,
                ticketId: ticketId,
                ticketStart: ticketStart
                //tariffPointId: tariffPointId
            }));
            this.request.setType("POST");
            this.request.setCallback(function (result) {
                if (result) {
                    if (result.Data) {
                        var data = result.Data;
                        for (var i = 0; i < data.length; i++) {

                            var descriptionLong = data[i].DescriptionLong;
                            var tariffPointIdent = data[i].Ident != null || data[i].Ident != undefined ? data[i].Ident : "";

                            if (showTairfPointIdent == true && tariffPointIdent != "") {
                                descriptionLong = descriptionLong + " (" + tariffPointIdent + ")";
                            }

                            me.TariffPoints.push({
                                Id: data[i].Id,
                                Ident: tariffPointIdent,
                                DescriptionShort: data[i].DescriptionShort,
                                DescriptionLong: descriptionLong,
                                Version: data[i].Version,
                                Pv: data[i].Pv,
                                TariffPointType: data[i].TariffPointType,
                                ContractStart: data[i].ContractStart
                            });
                        }
                    }
                }
                var id = me.Id ? me.Id : "TariffPoint";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }, {
        key: "GetTariffPointsByTicketIdWithCustomerAbove",
        value: function GetTariffPointsByTicketIdWithCustomerAbove(ticketId, searchString, ticketStart, tariffPointId, customerAboveId) {
            var me = this;

            this.request.setRequest("/customerAbove/" + customerAboveId + "/TariffPoints");
            this.request.setData(JSON.stringify({
                searchString: searchString,
                ticketId: ticketId,
                ticketStart: ticketStart
                //tariffPointId: tariffPointId
            }));
            this.request.setType("POST");
            this.request.setCallback(function (result) {
                if (result) {
                    if (result.Data) {
                        var data = result.Data;
                        for (var i = 0; i < data.length; i++) {

                            var tariffPointIdent = data[i].Ident != null || data[i].Ident != undefined ? data[i].Ident : "";

                            me.TariffPoints.push({
                                Id: data[i].Id,
                                Ident: tariffPointIdent,
                                DescriptionShort: data[i].DescriptionShort,
                                DescriptionLong: data[i].DescriptionLong,
                                Version: data[i].Version,
                                Pv: data[i].Pv,
                                TariffPointType: data[i].TariffPointType,
                                ContractStart: data[i].ContractStart
                            });
                        }
                    }
                }
                var id = me.Id ? me.Id : "TariffPointCustomerAbove";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }]);

    return TariffPointsModel;
}(_Observer3.default);

exports.default = TariffPointsModel;